import Layout from '../components/Layout';
import ProjectCard from '../components/projects/ProjectCard';
import dragonSlayerLogo from '../assets/dragon-slayer.jpeg';
import mlOpsLogo from '../assets/python.png';
import pokeSearchLogo from '../assets/poke-thumbnail.png';
import kubeflowLogo from '../assets/kubeflow.png';
import databricksLogo from '../assets/databricks_dab.png';
import sagemakerLogo from '../assets/sagemaker_platform.png';
import socialAnalyticsLogo from '../assets/social_analytics.png';
import '../styles/Projects.css';

export default function Projects() {
  const projects = [
    {
      title: "Databricks Asset Bundles (DAB)",
      tagline: "CI/CD Framework for Databricks",
      description: "A robust CI/CD framework for Databricks integrating Claude AI-powered PR reviews, UC Volume wheel publishing, and automated deployment.",
      image: databricksLogo,
      link: "https://www.databricks.com/product/machine-learning"
    },
    {
      title: "SageMaker CI/CD Platform",
      tagline: "Automated ML Infrastructure",
      description: "Reusable GitHub Actions workflows and pre-built GPU training images with MLflow model-registry integration on AWS SageMaker.",
      image: sagemakerLogo,
      link: "https://aws.amazon.com/sagemaker/"
    },
    {
      title: "Social Media Analytics",
      tagline: "Enterprise MLOps pipelines",
      description: "Standardized MLOps pipelines leveraging Airflow, BigQuery and Spark to provide insights into Social Media perception and resonance.",
      image: socialAnalyticsLogo,
      link: "https://cloud.google.com/vertex-ai"
    },
    {
      title: "PokeSearch",
      tagline: "A Pokemon card search engine",
      description: "A web application that allows you to search for Pokemon cards and build decks.",
      image: pokeSearchLogo,
      link: "/poke-search"
    },
    {
      title: "Dragon Slayer",
      tagline: "A game about taming dragons",
      description: "A single-player Android game built with Kotlin and Jetpack Compose. Created as a father-son project, available on the Google Play Store.",
      image: dragonSlayerLogo,
      link: "/dragon-slayer"
    },
    {
      title: "ML Ops - Python",
      tagline: "Test-Driven Development for MLOps",
      description: "Check out this series of blog posts on how to implement TDD for MLOps in Python with Gitlab CI/CD and Google Cloud.",
      image: mlOpsLogo,
      link: "/blog/python-ml-testing-p1"
    },
    {
      title: "Kubeflow",
      tagline: "An ML-Ops approach for Kubeflow Pipelines",
      description: "A series of blog posts on how to implement ML-Ops for Kubeflow Pipelines targetting Google Cloud and Vertex AI.",
      image: kubeflowLogo,
      link: "/blog/kubeflow-p1"
    }
  ];

  return (
    <Layout>
      <div className="projects-container">
        <div className="projects-content">
          <div className="projects-intro">
            <h1 className="projects-intro-title">My Projects</h1>
            <p className="projects-intro-text">
              Explore my portfolio of personal and professional projects, ranging from cloud-native search engines to mobile applications.
              Each project demonstrates my focus on clean architecture, MLOps automation, and user-centered design.
            </p>
          </div>
          <div className="projects-grid">
            {projects.map((project) => (
              <ProjectCard key={project.title} project={project} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}